import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CONTACT = {
  phone: "0684099561",
  phoneDisplay: "06 84 09 95 61",
  whatsapp: "31684099561",
  email: "info@ataiwo-installatietechniek.nl",
  companyName: "Ataiwo Installatietechniek",
  website: "ataiwo-installatietechniek.nl",
  kvk: "94261172",
  region: "Amsterdam en Noord-Holland",
  tagline: "Uw installatie, onze zorg",
  services: ["Elektra", "Installaties", "Storingen", "Onderhoud"],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmd8ZW58MHx8fHwxNzgzOTMwMDY2fDA&ixlib=rb-4.1.0&q=75&w=1600",
  groepenkast: "https://images.unsplash.com/photo-1576446470246-499c738d1c8e?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxjaXJjdWl0JTIwYnJlYWtlciUyMHBhbmVsfGVufDB8fHx8MTc4MzkzMDA2Nnww&ixlib=rb-4.1.0&q=75&w=800",
  storingen: "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2FsJTIwd2lyaW5nfGVufDB8fHx8MTc4MzkzMDA2NXww&ixlib=rb-4.1.0&q=75&w=800",
  verlichting: "https://images.unsplash.com/photo-1515948725-edac7b5bb0fc?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBsaWdodGluZyUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODM5MzAwNjZ8MA&ixlib=rb-4.1.0&q=75&w=800",
  amsterdam: "https://images.unsplash.com/photo-1459679749680-18eb1eb37418?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxhbXN0ZXJkYW0lMjBjaXR5fGVufDB8fHx8MTc4MzkzMDA2NXww&ixlib=rb-4.1.0&q=70&w=1400",
};

/**
 * Build a responsive srcset for an Unsplash image URL. The base URL already
 * carries fm=webp; we just override the `w=` parameter across widths.
 */
export function unsplashSrcSet(url, widths = [480, 800, 1200, 1600]) {
  if (!url || !url.includes("images.unsplash.com")) return undefined;
  return widths.map((w) => `${url.replace(/([?&])w=\d+/, `$1w=${w}`)} ${w}w`).join(", ");
}

export function formatApiError(detail) {
  if (detail == null) return "Er is iets misgegaan. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
